<template>
  <div class="Recordpage">
    <div class="Recordtime">
      <span>缴费时间：</span>
      <span class="sel" @click="checkPickerOption">{{ timeType }}</span>
    </div>
    <div class="Recordinfo">
      <div class="flex">
        <span class="listline"></span>
        <p class="Recordlisttit">
          <span class="title">住院信息</span>
        </p>
        <div class="Recordlistcon">
          <p>
            <span>入院诊断：</span>
            <span>{{PatInfo.IpDiagnosis}}</span>
          </p>
          <p>
            <span>入院科室：</span>
            <span>{{PatInfo.IpDptName}}</span>
          </p>
          <p>
            <span>入院日期：</span>
            <!-- moment(PatInfo.IpDate).format('YYYY-MM-DD HH:mm:ss') -->
            <span class="mr18">{{PatInfo.IpDate}}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="RecordList" v-for="(item,index) in paymentRecord.PayDetail" :key="index">
      <ul>
        <li class="tit">
          <span>缴费记录</span>
          <span>金额（元）</span>
        </li>
        <li>
          <p>
            <span>{{item.AccountWayName}}</span>
            <span>{{item.PaymentDate}}</span>
          </p>
          <p>
            <span>{{item.Amount}}</span>
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import BScroll from "better-scroll";
import {GetIpPaymentRecordByIpNo } from "@/services/getData.js";
import weui from "weui.js";
import moment from 'moment';
export default {
  name: "inspection-result",
  created: function() {
    //active 切换事件
    this.ipNo = this.$route.query.ipNo;
    this.GetIpPaymentRecordByIpNo();
  },
  data() {
    return {
      timeType: "七天内",
      ipNo:"",
      paymentRecord:{},
      PatInfo:{
        IpDiagnosis: "",
        IpDptName: "",
        IpDate: ""

      },
      moment: moment
    };
  },
  methods: {
    checkPickerOption: function() {
      var _that = this;
      weui.picker(
        [
          {
            label: "七天内",
            value: 0
          },
          {
            label: "三个月内",
            value: 1
          },
          {
            label: "半年内",
            value: 2
          }
        ],
        {
          onChange: function(result) {
            // console.log(result);
          },
          onConfirm: function(result) {
            _that.timeType = result["0"]["label"];
            _that.GetIpPaymentRecordByIpNo(result["0"]["value"]);
          }
        }
      );
    },
    GetIpPaymentRecordByIpNo:function(selectType){
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });
      GetIpPaymentRecordByIpNo(this.ipNo,selectType).then(response => {
        loading.hide();
        var _this = this;
        if (response.data.Result) {
          //跳转到主页
          this.paymentRecord = response.data.Extend;
          this.PatInfo = this.paymentRecord.PatInfo;

        } else {
          this.$dialog = weui.dialog({
            title: "提示",
            content: response.data.Content,
            buttons: [
              {
                label: "确定",
                type: "primary",
                onClick: function() {

                }
              }
            ]
          });
        }
      });
    }
  }
};
</script>
<style lang="scss">
.Recordpage {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.Recordpage .Recordtime {
  padding: 0.2rem;
  height: auto;
  font-size: 0.22rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.Recordpage .Recordtime .sel {
  width: 1.5rem;
  height: 0.4rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.2rem;
  line-height: 0.4rem;
  /* text-align: center; */
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  padding-left: 0.2rem;
}
.Recordpage .Recordtime .sel::after {
  position: absolute;
  display: inline-block;
  content: "";
  right: 0.18rem;
  width: 0;
  height: 0rem;
  border-width: 0.11rem 0.07rem;
  border-style: solid;
  border-color: #333333 transparent transparent transparent;
  font-size: 0.18rem;
  color: #fefefe;
  top: 0.15rem;
}

.Recordpage .Recordinfo {
  box-sizing: border-box;
  width: 100%;
  height: auto;
  background-color: white;
  position: relative;
  display: flex;
  flex-direction: column;
}

.Recordpage .Recordlisttit {
  font-size: 0.26rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: #1592e4;
  border-bottom: 0.01rem solid rgba(61, 151, 209, 1);
  height: 0.8rem;
  line-height: 0.8rem;
  padding-left: 0.2rem;
  box-sizing: border-box;
  width: 100%;
}
.Recordpage .listline {
  display: block;
  position: absolute;
  width: 0.08rem;
  height: 0.8rem;
  background: rgba(21, 146, 228, 1);
  top: 0;
  left: 0;
}
.Recordpage .Recordlistcon {
  width: 100%;
  box-sizing: border-box;
  padding: 0.2rem;
}
.Recordpage .Recordinfo .Recordlistcon > p {
  width: 100%;
  height: 0.45rem;
  line-height: 0.45rem;
  font-size: 0.24rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
}
.Recordpage .RecordList {
  width: 100%;
}
.Recordpage .RecordList li {
  background: #ffffff;
  height: 0.8rem;
  padding: 0 0.4rem;
  box-sizing: border-box;
}
.Recordpage .RecordList li.tit {
  width: 100%;
  height: 0.8rem;
  line-height: 0.8rem;
  background: none;
  border: 0;
}
.Recordpage .RecordList li.tit span:last-child {
  float: right;
}
.Recordpage .RecordList li p {
  width: 50%;
  height: 100%;
  float: left;
  border-bottom: 0.01rem solid rgba(221, 221, 221, 1);
}
.Recordpage .RecordList li p:first-child span:first-child {
  line-height: 0.36rem;
  display: block;
  margin-top: 0.06rem;
}
.Recordpage .RecordList li p:first-child span:last-child {
  line-height: 0.3rem;
  color: #999999;
}
.Recordpage .RecordList li p:last-child {
  text-align: right;
  line-height: 0.8rem;
}
</style>



// WEBPACK FOOTER //
// src/components/IpPayment/IpPaymentRecord.vue